module.exports = __webpack_public_path__ + "static/media/HCRA Compliance Order - Kassam - Creative Design - Construction- August 18- 2023.7386c44a.pdf";